/**
 * App
 */

// React
import { FC, useState, useEffect } from 'react';

// Router
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Refree from './routes';
import handleError from './utils/handleError';
import PartnerRepository from 'client-sdk/src/Repository/partners-repository';

// Components
import Auth from './components/Auth';
import {
  Dialog,
  DialogActions,
  DialogTitle,
  Grid,
  IconButton,
} from '@material-ui/core';

// UI
import Root from './pages/root';
import ReactMarkdown from 'react-markdown';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { Helmet } from 'react-helmet';
import RonadIcons from './components/iconComponent';
import * as Sentry from '@sentry/react';
import Providers from './providers';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      display: 'flex',
      '& .MuiContainer-maxWidthXl': {
        maxWidth: '100%',
      },
    },
  })
);

const SentryRoute = Sentry.withSentryRouting(Route);
Sentry.init({
  dsn: "https://e179ac7c93bb0c49bcc0476f37e8c1b9@o4506965113110528.ingest.us.sentry.io/4506976177422336",
  integrations: [
    Sentry.reactRouterV5BrowserTracingIntegration({ history }),
    // or
    Sentry.reactRouterV4BrowserTracingIntegration({ history }),
  ],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,
});

const App: FC = (props: object) => {
  const classes = useStyles();
  const [openChangeLogModal, setOpenChangeLogModal] = useState(false);
  const [changeLogInfo, setChangeLogInfo] = useState([]);

  const logOut = () => {
    localStorage.clear()
    window.location.href = '/login';
  }
  // const [serialPort, setSerialPort] = useState(null)

  // const getChangesHandler = async (today: any, lastSeen: any) => {
  //   GetChangeLogs.getChangeLoge({
  //     from: lastSeen ? lastSeen : today,
  //     type: 'PARTNER',
  //   })
  //     .then(res => {
  //       setChangeLogInfo(res.data);
  //       if (res.data.length > 0) {
  //         setOpenChangeLogModal(true);
  //       }
  //       localStorage.setItem('lastSeen', today);
  //     })
  //     .catch(err => {
  //       handleError(err);
  //       setOpenChangeLogModal(false);
  //     });
  // };
  useEffect(() => {
    // const today = `${new Date().getFullYear()}-${(
    //   '0' +
    //   (new Date().getMonth() + 1)
    // ).slice(-2)}-${('0' + new Date().getDate()).slice(-2)}`;

    // const lastSeen = localStorage.getItem('lastSeen');
    // const token = localStorage.getItem('token');
    const profile = localStorage.getItem('profile');
    const partnerId = localStorage.getItem("partnerId")

    window.onmessage = function(e) { // inside the parent
      // console.log("test =",e.data)
      // console.log('json ===>',JSON.parse(e.data))
      try {
        const data = JSON.parse(e.data)
          if(data.url) {
              // console.log('url ===>',data.url)
              window.open(data.url, '_blank')
          }
          if(data.command && data.command === 'LOGOUT') {
            logOut()
          }
      } catch (error) {
          // console.log(error)
      }
    };

    // if (lastSeen !== today && token !== '') {
    //   getChangesHandler(today, lastSeen);
    // }

    if(!profile && partnerId) {
      getProfile(partnerId)
    }
  }, []);

  const getProfile = async (partnerId:string) => {
    try {
      var partner = await PartnerRepository.getPartnerWithId({payload: {id: partnerId}})
      partner.data.profile && localStorage.setItem("profile", JSON.stringify(partner.data.profile.features.map(el => el.code)))
    } catch (error) {
      //errorHandling
    }
  }

  const onClose = () => {
    setOpenChangeLogModal(false);
  };

  // const serialTest = async () => {
  //   if(serialPort) {
  //     const encoder = new TextEncoder();
  //     const writer = serialPort.writable.getWriter();
  //     await writer.write(encoder.encode("PING"));
  //     writer.releaseLock();
  //     const reader = serialPort.readable.getReader();
  //     const { value, done } = await reader.read();
  //     console.log(new TextDecoder().decode(value))
  //     reader.releaseLock();
  //     console.log(serialPort.readable)
  //   }
  // }

  // const sendData = async () => {
  //   const port = await navigator.serial.requestPort();
  //   await port.open({ baudRate: 115200 });
  //   setSerialPort(port)
  // }

  return (
    <Router>
      <Switch>
        <SentryRoute exact path='/' component={Root} />
        <Providers>
          <Auth>
            <div className={classes.root}>
              <Refree />
            </div>
            <Dialog
              fullWidth
              open={openChangeLogModal}
              onClose={onClose}
              aria-labelledby='responsive-dialog-title'
            >
              <DialogTitle>
                <div
                  style={{
                    position: 'absolute',
                    left: '17px',
                    zIndex: 10
                  }}
                >
                  <IconButton aria-label='close' onClick={onClose}>
                    <RonadIcons name='times' size={0.8} />
                  </IconButton>
                </div>
                لیست تغییرات نسخه جدید
              </DialogTitle>
              <DialogActions>
                {changeLogInfo.map((el) => (
                  <Grid container spacing={1}>
                    <Grid item xs={4} style={{ padding: '20px' }}>
                      {el.date}
                    </Grid>
                    <Grid item xs={8} style={{ padding: '20px' }}>
                      <ReactMarkdown parserOptions={{ commonmark: true }}>
                        {el.description}
                      </ReactMarkdown>
                    </Grid>
                  </Grid>
                ))}
              </DialogActions>
            </Dialog>
            <Helmet>
              <script type='text/javascript'>
                {(function (c, l, a, r, i, t, y) {
                  c[a] =
                    c[a] ||
                    function () {
                      ;(c[a].q = c[a].q || []).push(arguments)
                    }
                  t = l.createElement(r)
                  t.async = 1
                  t.src = 'https://www.clarity.ms/tag/' + i
                  y = l.getElementsByTagName(r)[0]
                  y.parentNode.insertBefore(t, y)
                })(window, document, 'clarity', 'script', 'lmlr9q170l')}
              </script>
            </Helmet>
          </Auth>
        </Providers>
      </Switch>
    </Router>
  )
};

export default App;
